import { CookieStorageManager } from '@helpers/utils';

export const COOKIE_STORAGE_NAMESPACE = 'web';
const COOKIE_DOMAIN = import.meta.env.VITE_COOKIE_DOMAIN;

export const COOKIE_STORAGE_KEY = {
  IMPERSONATED_TOKEN: 'impersonatedToken',
  SESSION_ID: 'sessionId',
} as const;

export const csManager = new CookieStorageManager(
  COOKIE_STORAGE_NAMESPACE,
  COOKIE_STORAGE_KEY,
  COOKIE_DOMAIN,
);
